














import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component({
  model: {
    prop: 'checked',
    event: 'change'
  }
})
export default class AtomRadioButton extends ComponentVue {
  @Prop({ type: String })
  name!: string

  @Prop({ type: [String, Number, Boolean] })
  value!: string | number | boolean

  @Prop({ type: [String, Number, Boolean] })
  checked!: string | number | boolean

  @Prop({ type: String })
  label!: string

  @Prop({ type: Boolean, default: false })
  disabled!: boolean

  @Prop({ type: Number, default: 500 })
  emitIntervalMs!: number

  isEmit: boolean = true

  get internalValue(): string | number | boolean {
    return this.checked
  }

  set internalValue(newVal: string | number | boolean) {
    if (this.checked !== newVal) this.$emit('change', newVal)
  }

  onKeydownEnter() {
    if (this.isEmit) {
      this.$emit('keydown:enter')
      this.isEmit = false

      setTimeout(() => (this.isEmit = true), this.emitIntervalMs)
    }
  }

  // ラジオボタンの選択ではなく、「ラジオボタンを押下」した場合のイベント
  // 選択済みラジオボタンの押下でフォーカスの処理を行いたい等押下後処理する場合があるので追加
  @Emit('click')
  onClick(): void {}
}
